<script setup lang="ts">
import type { ISectionApplianceCardAppliance } from "#/ui-kit/components/section/appliances/section-appliance-category.types";

import SectionApplianceIcon from "#/ui-kit/components/section/appliances/section-appliance-icon.vue";
import { DATA_TEST_IDS } from "@voltalis/frontend-utils";

interface IProps {
  appliance: ISectionApplianceCardAppliance;
}

const props = defineProps<IProps>();
</script>

<template>
  <div
    class="section-appliance-card"
    :data-test-id="DATA_TEST_IDS.components.siteSectionApplianceCard.component"
  >
    <div :data-test-id="DATA_TEST_IDS.components.siteSectionApplianceCard.applianceIcon">
      <SectionApplianceIcon
        :section-appliance-category="props.appliance.category"
        size="large"
      />
    </div>
    <div class="flex flex-col min-w-0 flex-1">
      <span
        class="font-semibold overflow-hidden whitespace-nowrap text-ellipsis text-base"
        :title="props.appliance.name"
        :data-test-id="DATA_TEST_IDS.components.siteSectionApplianceCard.applianceName"
        >{{ props.appliance.name }}</span
      >
      <span
        class="overflow-hidden whitespace-nowrap text-ellipsis text-gray-500"
        :title="`${props.appliance.applianceId}`"
        :data-test-id="DATA_TEST_IDS.components.siteSectionApplianceCard.applianceId"
        >{{ props.appliance.applianceId }}</span
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-appliance-card {
  @apply border rounded-2xl p-4 flex items-center;
  gap: 10px;
}
</style>
